import React from 'react'
import { Richtext } from '@christies/react/components/Editorial'
import { SelectValue, withParsedContext } from '../../withJSSContext'
import { RenderFields } from '../../utils'
import { TrackingEvents, track } from '@christies/react/utils'
import { TFunction } from 'i18next'

interface Props {
  parsedFields: {
    Text: string
    'Column Width': SelectValue<'6' | '8'>
    'Interaction Location': string
    'Section Position': SelectValue<'top' | 'bottom'>
  }
  parsedRouteFields: {
    'Story Theme': SelectValue<'light' | 'dark'>
  }
  parsedSitecoreContext: {
    'Discovery.Feature.Magazines.Analytics.Settings': {
      interactionDestinationByUrlPath?: Record<string, string>
    }
  }
  t: TFunction
}

const MagazinesRichTextModule: React.FC<Props> = ({ parsedFields, parsedRouteFields, parsedSitecoreContext }) => {
  const handleTrack = (event: React.MouseEvent): void => {
    const element = event.target as HTMLAnchorElement
    const urlPrefix =
      parsedSitecoreContext?.['Discovery.Feature.Magazines.Analytics.Settings']?.interactionDestinationByUrlPath

    const key =
      urlPrefix && Object.keys(urlPrefix).find((key): key is keyof typeof urlPrefix => element?.href?.includes(key))

    if (element?.tagName?.toLowerCase() === 'a' && element?.textContent) {
      track({
        event: TrackingEvents.INTERACTION,
        data: {
          interaction: {
            type: element?.textContent,
            location: parsedFields?.['Interaction Location'],
            ...(key && { destination: urlPrefix?.[key] }),
          },
        },
      })
    }
  }

  const richTextProps = {
    html: parsedFields?.['Text'],
    mdWidth: parsedFields?.['Column Width']?.key,
    theme: parsedRouteFields?.['Story Theme']?.key,
    onClick: handleTrack,
    position: parsedFields?.['Section Position']?.key,
  }

  return (
    <RenderFields parsedFields={parsedFields}>
      <Richtext {...richTextProps} />
    </RenderFields>
  )
}

export default withParsedContext(MagazinesRichTextModule as React.FC)
